import Vue from "vue";

export const RemarkEventBus = new Vue();